"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CyclesClient_1 = require("client/admin/CyclesClient");
const ReloadContext_1 = require("context/ReloadContext");
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const ModalDeleteEndCycle = ({ modalType, cycleId, cycleName, onCloseModal }) => {
    const { reload, reloadAdminCycles } = (0, ReloadContext_1.useReload)();
    const handleOnClick = async () => {
        const action = modalType === 'delete' ? CyclesClient_1.deleteCycle : CyclesClient_1.endCycle;
        const { data } = await action(cycleId);
        if (data) {
            onCloseModal();
            reload({ reloadAdminCycles: !reloadAdminCycles });
        }
    };
    return (react_1.default.createElement(Modal_1.default, { minWidth: 400, customClass: "max-w-[400px]", onClose: onCloseModal },
        react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)(modalType === 'delete' ? 'Delete Cycle' : 'End Cycle'), onClose: onCloseModal }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("p", { className: "typography-paragraph px-[24px]" }, (0, HelperUtils_1.getObjectiveLocale)(`Do you want to ${modalType === 'delete' ? 'delete' : 'end'} this [cycle_name] cycle?`).replace('[cycle_name]', cycleName))),
        react_1.default.createElement(Modal_1.default.Footer, { primaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Yes'),
                onClick: handleOnClick,
                variant: 'danger',
                dataCy: 'confirm-button'
            }, secondaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('No'),
                onClick: onCloseModal
            }, useBorder: false })));
};
exports.default = ModalDeleteEndCycle;
